import { Stack } from 'components';

import { ClientFormWrapper } from '../clientForm/clientForm';
import { Profile } from '../clientForm/profile';

const MobileClientForm = () => {
  return (
    <ClientFormWrapper>
      <Stack padding="8px">
        <Profile />
      </Stack>
    </ClientFormWrapper>
  );
};

export default MobileClientForm;
